<template>
  <v-tile
    ref="tile"
    :product="product"
    class="c-tile--live"
  >
    <div
      class="c-tile__wrapper"
      @mouseenter="toggleHover"
      @mouseleave="toggleHover"
    >
      <v-product-image
        :product="product"
        class="c-tile__image c-tile--live__image"
        :type="ImageType.COVER"
      ></v-product-image>
      <v-progress
        v-if="$section.tileProgress"
        :product="product"
        class="c-tile__progress"
      ></v-progress>
      <div
        v-if="isProgrammeDisabled"
        class="o-badge c-tile__badge c-tile__badge--left c-tile__badge--locked"
      >
        <i class="o-icon o-icon--lock c-tile__badge-icon"></i>
      </div>
      <v-badge
        :product="product"
        class="c-tile__badge"
        :counting="isHovered"
      ></v-badge>
    </div>
    <div class="c-tile__details u-color-primary">
      <h2
        v-dompurify-html="title"
        class="c-tile__title"
      ></h2>
      <div class="c-tile__time c-tile__subtitle">
        <i class="o-icon o-icon--time o-icon--align-middle"></i>
        <span>
          {{ product.since | getFormatedMonthDateWithTime }}
        </span>
      </div>
    </div>
  </v-tile>
</template>
<script>
  import { ImageType } from '@/shared/enums';
  import { VBadge, VProductImage, VProgress, VTile } from '@/index/shared/components';
  import { getFormatedMonthDateWithTime, meta } from '@/index/shared/filters';
  import { productMixin } from '@/index/shared/mixins';

  export default {
    components: {
      VBadge,
      VProductImage,
      VProgress,
      VTile,
    },
    enums: {
      ImageType,
    },
    filters: {
      meta,
      getFormatedMonthDateWithTime,
    },
    mixins: [
      productMixin,
    ],
    inject: ['$section'],
    props: {
      product: Object,
    },
    data() {
      return {
        keys: ['richTitle', 'rating'],
        detailsVisible: false,
        isHovered: false,
      };
    },
    computed: {
      title() {
        return meta(this.product, this.keys);
      },
    },
    methods: {
      toggleHover() {
        this.isHovered = !this.isHovered;
      },
    },
  };
</script>
